var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"app":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('n-header'),_vm._v(" "),_c('n-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }